<div class="iframe-wrapper" [style.transform]="scaleTransform()">
    <pcp-rubber-element-iframe
        [rubberImage]="rubberImage"
        [disableElementUsage]="disableElementUsage"
        (interactions)="rubberElementInteraction.next($event)"
    ></pcp-rubber-element-iframe>
</div>
